//#region frontend/islands/science-pagination-mobile.js
var SciencePaginationMobile = class extends window.HTMLElement {
	connectedCallback() {
		this.track = this.querySelector("[data-track]");
		this.circles = Array.from(this.querySelectorAll(".science-progress-circle-mobile"));
		this.ctas = Array.from(this.querySelectorAll("[data-mobile-cta]"));
		if (this.ctas.length) {
			this._onCtaChange = (event) => this.setActiveCta(event.detail.index);
			document.addEventListener("science:mobile-cta-change", this._onCtaChange);
		}
		if (!this.track || !this.circles.length) return;
		this._onChange = (event) => this.setActiveCircle(event.detail.index);
		document.addEventListener("science:chapter-change", this._onChange);
	}
	setActiveCta(index) {
		this.ctas.forEach((cta) => {
			const active = Number(cta.dataset.chapterIndex) === index;
			cta.classList.toggle("opacity-100", active);
			cta.classList.toggle("opacity-0", !active);
			cta.classList.toggle("pointer-events-none", !active);
			cta.toggleAttribute("inert", !active);
		});
	}
	setActiveCircle(index) {
		const circle = this.circles[index];
		if (!circle) return;
		this.circles.forEach((c, i) => {
			const active = i === index;
			c.classList.toggle("border-green", active);
			c.classList.toggle("bg-green", active);
			c.classList.toggle("text-cream", active);
			c.classList.toggle("border-pine", !active);
		});
		const target = circle.offsetLeft - this.track.clientWidth / 2 + circle.clientWidth / 2;
		this.track.style.scrollSnapType = "none";
		this.track.scrollTo({
			left: target,
			behavior: "smooth"
		});
		clearTimeout(this._restoreSnapTimer);
		this._restoreSnapTimer = setTimeout(() => {
			this.track.style.scrollSnapType = "";
		}, 500);
	}
	disconnectedCallback() {
		document.removeEventListener("science:chapter-change", this._onChange);
		document.removeEventListener("science:mobile-cta-change", this._onCtaChange);
		clearTimeout(this._restoreSnapTimer);
	}
};
window.customElements.define("science-pagination-mobile", SciencePaginationMobile);
//#endregion
